// What a snapshot is valid for. Imports nothing, so the E2E suite can read it
// without loading the course.

/**
 * The version of the rules that fold events into a state.
 *
 * Bump it when a reducer change would make a snapshot an older build folded
 * wrong rather than merely behind: every snapshot is then re-folded from the
 * event log, once, on the next start.
 *
 * 2: memories carry `peak`. A snapshot compacted before that lacks it, so a
 * lapsed key's peak read as its current stability.
 *
 * 3: states carry `slips`, the recent-mistakes list. A snapshot folded before
 * it has none, so every past miss would read as fixed.
 */
export const FOLD_RULES = 3;

/**
 * The key a local or remote snapshot is stored under and compared on: the
 * content version it was folded under, and the rules that folded it. Rules 1
 * was never written into the key, so a snapshot keyed on the bare content
 * version is a rules-1 snapshot and fails the comparison like any other.
 */
export const foldKey = (contentVersion: string): string => `${contentVersion}~r${FOLD_RULES}`;

/** The content version a key was folded under. A rules-1 key is the bare version. */
export const contentOf = (key: string): string => key.replace(/~r\d+$/, "");
